import { Controller } from "@hotwired/stimulus"


export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replaceAll(
      "NEW_VAT_ITEM",
      Date.now().toString()
    )
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {

    event.preventDefault()
    const row = event.target.closest("[data-vat-item-row]")
    if (!row) return
    const destroyInput = row.querySelector("input[name*='_destroy']")

    if (destroyInput) {
      destroyInput.value = "1"
      row.classList.add("d-none")
    } else {
      row.remove()
    }
  }

}
